export default __webpack_public_path__ + "static/media/5S.1ca57000.webp";